import React from "react";
import Layout from "../components/Common/Layout";
import Dashboard from "../components/Dashboard/Dashboard";

const DashboardPage = () => {
  return (
    <Layout>
      <Dashboard />
    </Layout>
  );
};

export default DashboardPage;
